import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';

/**
 * AR Payments are retired in favor of cash receipts. These paths survive only
 * so old links, tasks and bookmarks land on the cash receipts page.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-receivable/payments',
});

/** The retired payments list: straight to the cash receipts page. */
export const ArPaymentsIndexRoute = createRoute({
  getParentRoute: () => Route,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/accounts-receivable/cash-receipts', replace: true });
  },
});

/** One retired payment: the cash receipts page. */
export const ArPaymentDetailRoute = createRoute({
  getParentRoute: () => Route,
  path: '$arPaymentId',
  beforeLoad: () => {
    throw redirect({ to: '/accounts-receivable/cash-receipts', replace: true });
  },
});
